import { Skeleton } from "@/components/ui/skeleton";
import { Card, CardContent } from "@/components/ui/card";

export function MediaGridSkeleton() {
  return (
    <div className="container mx-auto px-4 py-8 space-y-8 animate-fade-in">
      {/* Hero Banner Skeleton */}
      <div className="relative h-[500px] rounded-2xl overflow-hidden">
        <Skeleton className="absolute inset-0" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent" />
        <div className="absolute bottom-12 left-12 space-y-4 max-w-2xl">
          <Skeleton className="h-14 w-3/4" />
          <Skeleton className="h-6 w-1/2" />
          <div className="flex gap-4 mt-6">
            <Skeleton className="h-12 w-32" />
            <Skeleton className="h-12 w-32" />
          </div>
        </div>
      </div>

      {/* Filters Skeleton */}
      <div className="flex gap-4 flex-wrap">
        {[...Array(5)].map((_, i) => (
          <Skeleton key={i} className="h-10 w-24 rounded-full" />
        ))}
      </div>

      {/* Media Grid Skeleton */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
        {[...Array(20)].map((_, i) => (
          <Card key={i} className="elevation-3 overflow-hidden group">
            <div className="relative">
              <Skeleton className="aspect-[2/3] w-full" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
            <CardContent className="p-4 space-y-2">
              <Skeleton className="h-5 w-full" />
              <Skeleton className="h-4 w-3/4" />
              <div className="flex gap-2">
                <Skeleton className="h-6 w-12 rounded-full" />
                <Skeleton className="h-6 w-16 rounded-full" />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
